module.exports = __webpack_public_path__ + "static/media/skin.af24f224.jpg";